import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3473ea51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "qtt-btn-container" }
const _hoisted_4 = { class: "total" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge-pending" }, "Pendent", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "scan-info" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_number_spinner = _resolveComponent("number-spinner")!
  const _component_tip = _resolveComponent("tip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.paymentInfo.payment_type === null)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
        }, [
          _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("payment.back")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h4", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("payment.splitBillTitle")), 1),
      (_ctx.paymentInfo.split_bill_num_pax_paid === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("payment.splitBillNumPplQuestion")), 1))
        : _createCommentVNode("", true),
      (_ctx.paymentInfo.split_bill_num_pax_paid > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("payment.splitBillNumPpl")), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.paymentInfo.split_bill_num_pax_paid === 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateNumPax(_ctx.numPax - 1))),
            class: "btn-number"
          }, " - "))
        : _createCommentVNode("", true),
      _createVNode(_component_number_spinner, {
        modelValue: _ctx.numPax,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.numPax) = $event)),
        min: 2,
        max: 10
      }, null, 8, ["modelValue"]),
      (_ctx.paymentInfo.split_bill_num_pax_paid === 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateNumPax(_ctx.numPax + 1))),
            class: "btn-number"
          }, " + "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filters.currency(_ctx.paymentInfo.total)), 1),
    _createVNode(_TransitionGroup, {
      name: "split",
      tag: "ul",
      class: "split-parts"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numPax, (index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            (index > _ctx.paymentInfo.split_bill_num_pax_paid)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: '/assets/icon/split_bill.svg'
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (index <= _ctx.paymentInfo.split_bill_num_pax_paid)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: '/assets/icon/split_bill_paid.svg'
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(_ctx.total)) + " ", 1),
            (index <= _ctx.paymentInfo.split_bill_num_pax_paid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.paymentInfo.split_bill_users_paid[index - 1]), 1))
              : _createCommentVNode("", true),
            (index > _ctx.paymentInfo.split_bill_num_pax_paid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("payment.splitBillQrHint")), 1),
    _createVNode(_component_tip, {
      total: _ctx.total,
      onTipUpdated: _ctx.handleTipUpdated
    }, null, 8, ["total", "onTipUpdated"]),
    _createElementVNode("button", {
      class: "primary-btn",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('pay', { split_bill_num_pax: _ctx.numPax })))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("payment.pay")) + " ", 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.total + _ctx.tip)), 1)
    ]),
    _createElementVNode("small", {
      class: "payment-alert",
      innerHTML: _ctx.$t('payment.conditions')
    }, null, 8, _hoisted_12)
  ]))
}